module.exports = __webpack_public_path__ + "static/img/7050_phase_function_Paper_Points.c4c6de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7050_phase_function_Paper_Points.png
// module id = UGMw
// module chunks = 0